import React from 'react';

const Contact = () => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      margin: '1rem',
      marginTop: '6rem',
      gap: '2rem',
      minHeight: '600px',
      maxWidth: '1400px',
      marginLeft: 'auto',
      marginRight: 'auto'
    }}>

      <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
        <h1 style={{
          fontSize: '2.5rem',
          color: '#2c3e50',
          marginBottom: '1rem',
          fontWeight: '600'
        }}>
          Contact Us
        </h1>
        <p style={{
          fontSize: '1.2rem',
          color: '#7f8c8d',
          maxWidth: '600px',
          margin: '0 auto'
        }}>
          Email us directly at{' '}
          <a href="mailto:brentspenceucii@gmail.com" style={{ color: '#3498db', textDecoration: 'none' }}>
            brentspenceucii@gmail.com
          </a>
          . Your message will open in your email app and send to that address.
        </p>
      </div>

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        gap: '2rem',
        marginBottom: '3rem'
      }}>

        <div style={{
          padding: '2rem',
          backgroundColor: '#f8f9fa',
          borderRadius: '12px',
          border: '1px solid #e9ecef'
        }}>
          <h3 style={{
            fontSize: '1.5rem',
            color: '#2c3e50',
            marginBottom: '1.5rem',
            fontWeight: '600'
          }}>
            Contact Information
          </h3>

          <div style={{ marginBottom: '1rem' }}>
            <h4 style={{ fontWeight: '600', color: '#34495e', marginBottom: '0.5rem' }}>
              University of Cincinnati Infrastructure Institute (UCII)
            </h4>
            <p style={{ color: '#7f8c8d', margin: '0' }}>
              College of Engineering and Applied Science<br />
              University of Cincinnati<br />
              Cincinnati, OH 45221
            </p>
          </div>

          <div style={{ marginBottom: '1rem' }}>
            <h4 style={{ fontWeight: '600', color: '#34495e', marginBottom: '0.5rem' }}>
              Email
            </h4>
            <p style={{ color: '#3498db', margin: '0' }}>
              <a href="mailto:brentspenceucii@gmail.com" style={{ color: '#3498db', textDecoration: 'none' }}>
                brentspenceucii@gmail.com
              </a>
            </p>
          </div>

          <div style={{ marginBottom: '1rem' }}>
            <h4 style={{ fontWeight: '600', color: '#34495e', marginBottom: '0.5rem' }}>
              Phone
            </h4>
            <p style={{ color: '#7f8c8d', margin: '0' }}>
              (513) 556-6069
            </p>
          </div>
        </div>

        <div style={{
          padding: '2rem',
          backgroundColor: '#f8f9fa',
          borderRadius: '12px',
          border: '1px solid #e9ecef'
        }}>
          <h3 style={{
            fontSize: '1.5rem',
            color: '#2c3e50',
            marginBottom: '1.5rem',
            fontWeight: '600'
          }}>
            Project Team
          </h3>

          <div style={{ marginBottom: '1rem' }}>
            <h4 style={{ fontWeight: '600', color: '#34495e', marginBottom: '0.5rem' }}>
              Principal Investigators
            </h4>
            <p style={{ color: '#7f8c8d', margin: '0' }}>
              Dr. Arthur Helmicki<br />
              Dr. Victor Hunt<br />
              Electrical and Computer Engineering Department<br />
              University of Cincinnati
            </p>
          </div>

          <div style={{ marginBottom: '1rem' }}>
            <h4 style={{ fontWeight: '600', color: '#34495e', marginBottom: '0.5rem' }}>
              Research Team
            </h4>
            <p style={{ color: '#7f8c8d', margin: '0' }}>
              Graduate Students<br />
              Undergraduate Researchers<br />
              Technical Staff
            </p>
          </div>
        </div>

        <div style={{
          padding: '2rem',
          backgroundColor: '#f8f9fa',
          borderRadius: '12px',
          border: '1px solid #e9ecef'
        }}>
          <h3 style={{
            fontSize: '1.5rem',
            color: '#2c3e50',
            marginBottom: '1.5rem',
            fontWeight: '600'
          }}>
            Office Hours
          </h3>

          <div style={{ marginBottom: '1rem' }}>
            <h4 style={{ fontWeight: '600', color: '#34495e', marginBottom: '0.5rem' }}>
              General Inquiries
            </h4>
            <p style={{ color: '#7f8c8d', margin: '0' }}>
              Monday - Friday<br />
              8:00 AM - 5:00 PM EST
            </p>
          </div>

          <div style={{ marginBottom: '1rem' }}>
            <h4 style={{ fontWeight: '600', color: '#34495e', marginBottom: '0.5rem' }}>
              Technical Support
            </h4>
            <p style={{ color: '#7f8c8d', margin: '0' }}>
              Available during<br />
              business hours
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
